import * as React from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  color?: string;
  height?: string;
  width?: string;
  title?: string;
  titleId?: string;
}
const SvgPopup = (
  { color = 'currentColor', height = '24px', width = '24px', title, titleId }: SVGRProps,
  ref: Ref<SVGSVGElement>,
): JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    ref={ref}
    aria-labelledby={titleId}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M4 21h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2Zm0-2V7h16l.001 12H4Z"
      fill={color}
    />
    <path d="M13.5 13.5v4h5v-4h-5Z" fill={color} />
    <path fillRule="evenodd" clipRule="evenodd" d="M13 13h6v5h-6v-5Zm1 1v3h4v-3h-4Z" fill={color} />
  </svg>
);
const ForwardRef = forwardRef(SvgPopup);
export default ForwardRef;
